// TODO: Remove eslint-disable and update names
/* eslint-disable jsdoc/require-jsdoc */
import { EditorDefns } from "../../../utility";
import * as ARS from "../../ars_ldm";
import {
  ArsTableGroup,
  ArsTableOperation,
  ArsTableSubGroup,
  ArsTableSubGroupGroup,
  ArsTableSubGroupGroupingFactor,
} from "../interface";
import { isArsTableOperation, isArsTableSubGroupGroupingFactor } from "../typeguards";

export const arst_groupToTableGroup = <T>(
  group: ARS.Group,
  editorProps: EditorDefns<T>,
): ArsTableSubGroupGroup<T> => ({
  id: crypto.randomUUID(),
  label: editorProps.textToT(group.label ?? group.name),
  group: group,
});

export const arst_groupingFactorToTableGroup = <T>(
  groupingFactor: ARS.GroupingFactor,
  editorProps: EditorDefns<T>,
): ArsTableSubGroupGroupingFactor<T> => ({
  id: crypto.randomUUID(),
  groupingFactor: groupingFactor,
  label: editorProps.textToT(groupingFactor.label ?? groupingFactor.name),
  subGroups:
    "groups" in groupingFactor
      ? groupingFactor.groups?.map((group) => arst_groupToTableGroup(group, editorProps))
      : undefined,
});

export const arst_operationToTableGroup = <T>(
  operation: ARS.Operation,
  editorProps: EditorDefns<T>,
): ArsTableOperation<T> => ({
  id: crypto.randomUUID(),
  label: editorProps.textToT(operation.label ?? operation.name),
  operation,
});

export const arst_analysisMethodToTableGroup = <T>(
  analysisMethod: ARS.AnalysisMethod,
  editorProps: EditorDefns<T>,
): ArsTableSubGroup<T> => ({
  id: crypto.randomUUID(),
  label: editorProps.textToT(analysisMethod.label ?? analysisMethod.name),
  analysisMethod,
  subGroups: analysisMethod.operations.map((operation) =>
    arst_operationToTableGroup(operation, editorProps),
  ),
});

export const arst_tableGroupDepth = <T>(
  group: ArsTableGroup<T>,
  editorProps: EditorDefns<T>,
): number => {
  const subGroups = "subGroups" in group && group.subGroups ? group.subGroups : [];
  const subGroupDepth = Math.max(
    ...subGroups.map((subGroup) => arst_tableGroupDepth(subGroup, editorProps)),
    0,
  );
  const thisDepth =
    isArsTableSubGroupGroupingFactor(group, editorProps.isT) &&
    group.groupingFactor.dataDriven &&
    !group.hidden
      ? 2
      : isArsTableOperation(group, editorProps.isT) && group.hidden
        ? 0
        : 1;
  return thisDepth + subGroupDepth;
};
